import { render, staticRenderFns } from "./VlCardTitle.vue?vue&type=template&id=b708a170&scoped=true&"
import script from "./VlCardTitle.vue?vue&type=script&lang=js&"
export * from "./VlCardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b708a170",
  null
  
)

export default component.exports